// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divider{margin:10px 0;height:1px;background-color:#ddd}`, "",{"version":3,"sources":["webpack://./src/components/Divider/style.scss"],"names":[],"mappings":"AACA,SACE,aAAA,CACA,UAAA,CACA,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
